
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/image-to-text",
      function () {
        return require("private-next-pages/image-to-text/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/image-to-text"])
      });
    }
  